spec_version: '1.1'
id: 3
slug: 03-eliminacion-de-deudas
titulo: Eliminación de deudas
duracion_min: 90
estado: placeholder
fase_produccion: 0
ultima_actualizacion: '2026-06-15'
prerrequisitos: []
objetivos_aprendizaje:
- id: OA-03.1
  texto: Clasificar tus deudas por tipo y coste real
  bloom: ''
- id: OA-03.2
  texto: Aplicar el método de amortización que mejor se ajuste a tu perfil
  bloom: ''
- id: OA-03.3
  texto: Identificar oportunidades de renegociación o subrogación
  bloom: ''
glosario: []
secciones:
- tipo: teoria
  archivo: teoria.md
- tipo: quiz-practica
  archivo: quiz-practica.md
- tipo: recursos
  archivo: recursos.md
sub_secciones_teoria:
- id: '3.1'
  titulo: 'Tipos de deuda: tóxica, neutra y productiva'
  duracion_min: 15
- id: '3.2'
  titulo: Tarjetas revolving y créditos al consumo
  duracion_min: 15
- id: '3.3'
  titulo: 'Hipoteca: amortizar o no amortizar'
  duracion_min: 20
- id: '3.4'
  titulo: Método avalancha vs bola de nieve
  duracion_min: 15
- id: '3.5'
  titulo: Renegociación y subrogación
  duracion_min: 15
- id: '3.6'
  titulo: Qué hacer si la deuda es inasumible
  duracion_min: 10
